module.exports = __webpack_public_path__ + "img/series.e21b71.svg";